'use client';

import CaptureUTMParameters from '@/hooks/use-persist-utm.hook';
import { NextIntlClientProvider } from 'next-intl';

export default function IntlProvider({ locale, now, timeZone, messages, children }) {  
  CaptureUTMParameters();
  return (
    <NextIntlClientProvider
      // Define non-serializable props here
      defaultTranslationValues={{
        i: (text) => <i>{text}</i>,
      }}
      onError={(error) => console.error(error)}
      getMessageFallback={({ namespace, key }) => `${namespace}.${key}`}
      // Make sure to forward these props to avoid markup mismatches
      locale={locale}
      now={now}
      timeZone={timeZone}
      // Provide as necessary
      messages={messages}
    >
      {children}
    </NextIntlClientProvider>
  );
}
